import { useNewVersion } from '../lib/updateCheck.js';

/**
 * ehr#480 (reopened 10-18) - "A new version of the EHR is ready": shown once this tab is running
 * an older bundle than the one live. Reload is the person's call, never automatic, so a form or
 * note in progress is never thrown away.
 */
export function UpdateNotice() {
  const newer = useNewVersion();
  if (!newer) return null;
  return (
    <div className="update-notice" role="status" aria-live="polite">
      <span>A new version of the EHR is ready. Save your work, then reload to get it.</span>
      <button type="button" className="update-notice-btn" onClick={() => window.location.reload()}>
        Reload
      </button>
    </div>
  );
}
